module.exports = __webpack_public_path__ + "officialStatic/img/detail-diffict9.e9aa67c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-diffict9.png
// module id = y2de
// module chunks = 0